import Link from 'next/link';
import { ArrowRight } from 'react-feather';

// Хэсгийн гарчиг: жижиг том үсэгтэй eyebrow + serif гарчиг, баруун талд сонголтоор холбоос.
const SectionHeading = ({
    eyebrow,
    title,
    href,
    linkLabel,
    light = false,
    className = '',
}) => (
    <div className={`flex items-end justify-between gap-6 ${className}`}>
        <div>
            {eyebrow ? (
                <p
                    className={`flex items-center gap-3 text-[10px] sm:text-[11px] uppercase tracking-[0.25em] ${
                        light ? 'text-paper/60' : 'text-stone'
                    }`}
                >
                    {/* Орчин үеийн жижиг зураасан accent */}
                    <span className="w-6 h-px bg-current opacity-60" />
                    {eyebrow}
                </p>
            ) : null}
            <h2
                className={`mt-2 font-serif text-[28px] sm:text-[36px] leading-[1.1] ${
                    light ? 'text-paper' : 'text-ink'
                }`}
            >
                {title}
            </h2>
        </div>
        {href && linkLabel ? (
            <Link
                href={href}
                className={`group shrink-0 inline-flex items-center gap-1.5 text-[12px] border-b pb-0.5 transition-colors ${
                    light
                        ? 'text-paper border-paper/40 hover:border-paper'
                        : 'text-ink border-ink/30 hover:border-ink'
                }`}
            >
                {linkLabel}
                <ArrowRight
                    size={13}
                    className="transition-transform duration-200 group-hover:translate-x-0.5"
                />
            </Link>
        ) : null}
    </div>
);

export default SectionHeading;
